import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { TrendingUp } from "lucide-react";
import * as React from "react";

export const LoadingCard = ({ className }: { className?: string }) => (
  <Card
    className={cn(
      "col-span-12 flex h-[154px] flex-col p-4 text-thalo-foreground",
      className
    )}
  >
    <div className="flex h-80 w-full flex-1 animate-pulse flex-col items-center justify-center rounded">
      <TrendingUp size={48}/>
      <p>Loading</p>
    </div>
  </Card>
);
